import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMGoogleAccountResource {
  static getGoogleAccount(queries, completion){
    queries["per_page"] = queries["per_page"] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/owners/" + queries['owner_id'] + "/google_account.json";
    const apiClient = new SMRestClient();
    apiClient.get(url + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        if(xhr.status === 404) {
          completion({}, error, xhr);
        } else {
          console.error(error);
          completion(null, error, xhr);
        }
      });
  }

  static updateGoogleAccount(owner_id, formData, queries, completion) {
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/owners/" + owner_id + "/google_account.json" + q;
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }

  static deleteGoogleAccount(owner_id, completion){
    const url = "/1/owners/" + owner_id + "/google_account.json";
    const apiClient = new SMRestClient();
    apiClient.destroy(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
}
export default SMGoogleAccountResource;


// WEBPACK FOOTER //
// ./app/javascript/resources/SMGoogleAccountResource.js